"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pkgName = void 0;
exports.pkgName = 'gatsby-source-sanity';
var getGatsbyImageProps_1 = require("./images/getGatsbyImageProps");
Object.defineProperty(exports, "getFluidGatsbyImage", { enumerable: true, get: function () { return getGatsbyImageProps_1.getFluidGatsbyImage; } });
Object.defineProperty(exports, "getFixedGatsbyImage", { enumerable: true, get: function () { return getGatsbyImageProps_1.getFixedGatsbyImage; } });
var resolveReferences_1 = require("./util/resolveReferences");
Object.defineProperty(exports, "resolveReferences", { enumerable: true, get: function () { return resolveReferences_1.resolveReferences; } });
//# sourceMappingURL=index.js.map